import { atom } from "jotai";
import type { ToastItemType } from "@landwich/shared/types";

export const toastAtom = atom<ToastItemType[]>([]);
